import { useState } from 'react';
import { motion } from 'framer-motion';
import { Mail } from 'lucide-react';

const JoinWaitlist = () => {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('Sending...');

    try {
      const response = await fetch('/api/subscribe', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });

      const data = await response.json().catch(() => ({}));
      if (response.ok) {
        setStatus("You're on the mailing list!");
      } else {
        setStatus(`Failed: ${data.message || 'Please try again.'}`);
      }
    } catch (error) {
      setStatus('An error occurred. Please try again.');
    }

    setTimeout(() => {
      setEmail('');
      setStatus('');
    }, 4000);
  };

  return (
    <section className="relative py-24 px-4 scroll-mt-24 bg-white">
      <div className="relative z-10 max-w-xl mx-auto">
        <motion.div
          className="bg-[#f7f8f7] border border-gray-100 rounded-3xl p-10 md:p-12 text-center shadow-sm"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h2 className="text-3xl md:text-4xl font-bold text-[#3a3a3a] mb-4">
            Join Our Mailing List
          </h2>
          <p className="text-[#6b7280] text-lg mb-8 leading-relaxed">
            Stay up to date with new updates and announcements! Sign up below.
          </p>

          <form onSubmit={handleSubmit} className="flex flex-col gap-4">
            <div className="relative">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email"
                required
                className="w-full bg-white border border-gray-200 rounded-full py-3 px-5 pr-12 text-[#3a3a3a] placeholder-[#9ca3af] focus:outline-none focus:ring-2 focus:ring-[#6B8F8A]/30 focus:border-[#6B8F8A]/30 transition-all"
              />
              <Mail className="absolute right-4 top-1/2 -translate-y-1/2 w-5 h-5 text-[#9ca3af]" />
            </div>
            <motion.button
              type="submit"
              className="bg-[#6B8F8A] hover:bg-[#5a7f7a] text-white font-semibold py-3 px-8 rounded-full transition-colors duration-200 shadow-md hover:shadow-lg mx-auto"
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
            >
              Sign Up
            </motion.button>
          </form>

          {status && (
            <motion.p
              className={`mt-4 text-sm font-medium ${
                status.includes('Failed') || status.includes('error')
                  ? 'text-red-500'
                  : status === 'Sending...'
                  ? 'text-[#6b7280]'
                  : 'text-[#6B8F8A]'
              }`}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
            >
              {status}
            </motion.p>
          )}
        </motion.div>
      </div>
    </section>
  );
};

export default JoinWaitlist;
